// extracted by mini-css-extract-plugin
export default {"list":"styles_list__w4G5J","item":"styles_item__Y13A9"};